/**
 * Bootstrap-Vue 2.23 patches Vue's v-model with el._assign, but Vue 3.3.5+
 * stores the assigner on Symbol("_assign"). Without this, b-form-checkbox /
 * b-form-radio / b-form-select throw "assign is not a function" on change.
 *
 * @see https://github.com/bootstrap-vue/bootstrap-vue/issues/7182
 */
import Vue from 'vue'

export function patchBootstrapVueModelAssign() {
  if (!Vue?.vModelDynamic) {
    return
  }

  const originalCreated = Vue.vModelDynamic.created
  const originalBeforeUpdate = Vue.vModelDynamic.beforeUpdate
  let assignSymbol

  const ensureAssign = (el) => {
    if (!el) {
      return
    }

    if (!assignSymbol) {
      assignSymbol = Object.getOwnPropertySymbols(el).find((symbol) => symbol.description === '_assign')
    }

    if (assignSymbol && typeof el[assignSymbol] !== 'function') {
      el[assignSymbol] = () => {}
    }

    if (typeof el._assign !== 'function') {
      el._assign = () => {}
    }
  }

  Vue.vModelDynamic.created = function patchedVModelDynamicCreated(el, binding, vnode) {
    if (typeof originalCreated === 'function') {
      originalCreated.call(this, el, binding, vnode)
    }
    ensureAssign(el)
  }

  Vue.vModelDynamic.beforeUpdate = function patchedVModelDynamicBeforeUpdate(el, binding, vnode) {
    if (typeof originalBeforeUpdate === 'function') {
      originalBeforeUpdate.call(this, el, binding, vnode)
    }
    ensureAssign(el)
  }
}
